export default defineNuxtRouteMiddleware(async (to) => {
  // Skip middleware on server-side, let it run on client only
  if (import.meta.server) {
    return;
  }

  const { status, data, getSession, signIn } = useAuth();

  // Handle admin routes - require authentication (role is checked on page level and API)
  if (to.path.startsWith('/admin')) {
    // Fetch session to ensure we have latest data
    await getSession({ required: false });

    // Check authentication status
    if (status.value !== 'authenticated') {
      return signIn(undefined, { callbackUrl: to.path }) as ReturnType<typeof navigateTo>;
    }

    // Role check is done in the page component itself and API endpoints
    return;
  }

  if (!to.path.startsWith('/account')) {
    return;
  }

  if (to.path === '/account/signin'
    || to.path === '/account/register'
    || to.path === '/account/signout'
    || to.path === '/account/verify-email'
    || to.path === '/account/verify-request'
    || to.path === '/account/magic-link-confirm'
    || to.path === '/account/forgot-password'
    || to.path === '/account/reset-password'
  ) {
    return;
  }

  if (status.value === 'authenticated') {
    return;
  }

  return signIn(undefined, {callbackUrl: to.path}) as ReturnType<typeof navigateTo>;
});
